<template lang="html">
  <div>
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <v-btn icon width="40" height="40" class="mr-2" @click="goBack()">
                <v-icon>
                  mdi-arrow-left
                </v-icon>
              </v-btn>
              <div class="title-page-text">
                {{ $t('v2.order_detail') }}
              </div>
              <v-spacer />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <div v-if="order.status_inquiry === 5" :class="['banner-resorder text-center', { 'order-success': order.status_inquiry === 5 }]">
            <div class="mb-4">
              <img src="@/assets/images/v2/img/icon_check.png" alt="" class="image-144 ma-auto">
            </div>
            <div class="font-16 font-weight-600">
              {{ $t('v2.order_completed') }}
            </div>
          </div>
          <!-- {{ order.payment_log }} -->
          <div class="pa-4 ol-elevation-2 br-8 mb-4">
            <div class="flex-image">
              <div v-if="!$isEmpty(order.logo)" class="flex-image-avatar mr-4">
                <img :src="order.logo.original" :alt="order.store_name" class="image-80">
              </div>
              <div class="flex-image-content">
                <div class="flex-image-content-text font-18 font-weight-700 mb-1">
                  {{ order.store_name }}
                </div>
                <div class="flex-image-content-text font-14 font-weight-400 mb-1">
                  <span v-mask-money="order.total_amount" />
                </div>
                <div class="flex-image-content-text">
                  <div :class="['status-order', { 'status-pending': order.status_inquiry === 1, 'status-confirm': order.status_inquiry === 2, 'status-ready': order.status_inquiry === 3 || order.status_inquiry === 4 , 'status-done': order.status_inquiry === 5, 'status-failed': order.status_inquiry === 6 || order.status_inquiry === 7 }]">
                    {{ order.status_desc }}
                  </div>
                </div>
              </div>
            </div>
            <template v-if="(!$isEmpty(order.payment_log) && order.payment_mode_id !== 10 && order.is_paid !== 1)">
              <div class="div-line my-4" />
              <div class="flex-image">
                <div class="flex-image-avatar mr-4">
                  <img v-if="order.payment_log.payment_type !== 'QRIS'" :src="order.payment_log.payment_image" :alt="order.payment_log.payment_source === 'VIRTUAL-ACCOUNT' ? order.payment_log.va_bank_code : order.payment_log.payment_type" class="image-40">
                  <img v-else :src="order.payment_log.qr_image" :alt="order.payment_log.payment_source" class="image-40">
                </div>
                <div class="flex-image-content">
                  <template v-if="order.payment_log.payment_source === 'VIRTUAL-ACCOUNT'">
                    <div class="flex-image-content-text font-14 font-weight-600">
                      {{ order.payment_log.va_account_number }}
                    </div>
                    <div class="flex-image-content-text font-12 font-weight-400">
                      {{ order.payment_log.va_bank_code }}
                    </div>
                  </template>
                  <div v-else class="flex-image-content-text font-14 font-weight-600">
                    {{ order.payment_log.payment_type }}
                  </div>
                </div>
                <v-btn v-if="order.payment_log.payment_source === 'VIRTUAL-ACCOUNT'" icon color="olbrand" class="ml-2 mirror">
                  <v-icon>
                    mdi-content-copy
                  </v-icon>
                </v-btn>
              </div>
              <div class="div-line my-4" />
              <div class="d-flex align-center">
                <div class="font-14 ol-black">
                  {{ $t('v2.total') }}
                </div>
                <v-spacer />
                <div class="font-14 font-weight-600">
                  <span v-mask-money="order.total_amount" />
                </div>
              </div>
            </template>
          </div>
          <div class="pa-4 ol-elevation-2 br-8">
            <div>
              <div class="d-flex align-center">
                <div>
                  <div class="font-12 font-weight-400 ol-grey-content">
                    {{ $t('v2.order_number') }}
                  </div>
                  <div class="font-18 font-weight-700">
                    {{ order.order_no }}
                  </div>
                </div>
                <v-spacer />
                <div v-if="order.remark === 'OL-DINE-IN'" class="d-flex align-center">
                  <div class="wrap-table">
                    <div class="wrap-table-icon">
                      <img :src="icon_table" :alt="$t('table')">
                    </div>
                    <div class="wrap-table-content">
                      <div class="wrap-table-text">
                        {{ $t('table') }} {{ order.table_no }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="order.remark === 'OL-TAKE-AWAY'" class="d-flex align-center">
                  <div class="wrap-table">
                    <div class="wrap-table-icon">
                      <img :src="require('@/assets/images/v2/img/icon_take_away.png')" :alt="$t('v2.takeaway')">
                    </div>
                    <div class="wrap-table-content">
                      <div class="wrap-table-text">
                        {{ $t('v2.takeaway') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="order.remark === 'DELIVERY'" class="d-flex align-center">
                  <div class="wrap-table">
                    <div class="wrap-table-icon">
                      <img :src="require('@/assets/images/v2/img/icon-side-delivery.png')" :alt="$t('v2.delivery')">
                    </div>
                    <div class="wrap-table-content">
                      <div class="wrap-table-text">
                        {{ $t('v2.delivery') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="order.remark === 'RESERVATION'" class="d-flex align-center">
                  <div class="wrap-table">
                    <div class="wrap-table-icon">
                      <img :src="icon_side_reservation" :alt="order.remark">
                    </div>
                    <div class="wrap-table-content">
                      <div class="wrap-table-text">
                        {{ order.remark }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="div-line my-4" />
            <div>
              <div class="d-flex align-center">
                <div class="font-14 font-weight-400">
                  {{ $t('v2.date') }}
                </div>
                <v-spacer />
                <div class="font-14 font-weigth-600">
                  {{ order.forder_date }}, {{ order.forder_time }}
                </div>
              </div>
            </div>
          </div>

          <div v-if="order.remark === 'RESERVATION'" class="mt-4">
            <div class="pa-4 ol-elevation-2 br-8">
              <div>
                <div>
                  <div class="d-flex justify-space-between">
                    <div class="">
                      <div class="font-12 font-weight-400 ol-grey-content mb-1">
                        {{ $t('v2.reservation_date') }}
                      </div>
                      <div class="font-18 font-weight-700 ol-black">
                        {{ $formatDate(order.reserve_date, true) }}
                      </div>
                    </div>
                    <div>
                      <div class="font-12 font-weight-400 ol-grey-content mb-1">
                        {{ $t('v2.time') }}
                      </div>
                      <div class="font-18 font-weight-700 ol-black">
                        {{ order.freserve_time }}
                      </div>
                    </div>
                    <div>
                      <div class="font-12 font-weight-400 ol-grey-content mb-1">
                        {{ $t('v2.number_of_tables') }}
                      </div>
                      <div class="font-18 font-weight-700 ol-black">
                        {{ order.total_guest }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="div-line my-4" />
                <v-btn outlined color="olbrand" block height="40" class="text-none br-5 font-weight-700 font-16" @click="updateReservation()">
                  {{ $t('v2.change') }}
                </v-btn> -->
              </div>
            </div>
          </div>

          <div class="list-item-checkout mt-4">
            <template v-for="(item, idx) in order.items">
              <div v-if="item.note !== 'REDEEMED'" :key="idx" class="container-item-checkout">
                <div class="item-checkout">
                  <div class="item-checkout-qty font-16 font-weight-600 ol-brand mr-2">
                    {{ item.qty }}x
                  </div>
                  <div class="item-checkout-content">
                    <div class="item-checkout-name font-16 font-weight-400 mb-1">
                      {{ item.item_name }} {{ item.item_variant_name ? '(' + item.item_variant_name + ')' : '' }}
                    </div>
                    <div class="item-checkout-text font-14 font-weight-700 mb-3">
                      <span v-mask-money="item.amount" />
                    </div>
                    <div v-if="textAddons(item) !== ''" class="item-checkout-text ol-accent font-12 font-weight-400 mb-1">
                      {{ textAddons(item) }}
                    </div>
                    <div v-if="item.note !== ''" class="item-checkout-text">
                      <div class="d-flex align-center">
                        <div class="mr-1">
                          <v-icon size="18" color="#767676" style="transform: rotate(180deg) scale(-1, 1);">
                            mdi-note-outline
                          </v-icon>
                        </div>
                        <div class="font-12 font-weight 400 ol-grey-content">
                          {{ notTakeaway(item.note) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="isTakeaway(item.note)" class="align-self-start ml-2">
                    <div class="font-12 font-weight-600 px-2 py-1 br-5 ol-black bg-grey">
                      {{ $t('v2.takeaway') }}
                    </div>
                  </div>
                </div>
                <div class="list-line" />
              </div>
            </template>
          </div>

          <div class="line-low my-4" />
          <div class="list-price">
            <div class="title-list-price">
              {{ $t('v2.price') }}
            </div>
            <div class="list-component-price">
              <div class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.subtotal') }}
                </div>
                <v-spacer />
                <div v-mask-money-only="order.order_amount" class="list-item-nominal-price" />
              </div>
              <div v-if="order.discount_amount > 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.discount') }}
                  <span v-if="order.discount_voucher_code && order.discount_voucher_code !== ''">
                    ({{ order.discount_voucher_code }})
                  </span>
                </div>
                <v-spacer />
                <div class="list-item-nominal-price ol-accent">
                  -<span v-mask-money-only="order.discount_amount" />
                </div>
              </div>
              <div v-if="!$isEmpty(order.points) && order.points.type === 'D' && Number(order.points.redeemed_amount) > 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.voucher_point') }}
                </div>
                <v-spacer />
                <div class="list-item-nominal-price ol-accent">
                  -
                  <span v-mask-money-only="order.points.redeemed_amount" />
                </div>
              </div>
              <div v-if="Number(order.service_charge_amount) > 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.service_charge') }}
                </div>
                <v-spacer />
                <div v-mask-money-only="order.service_charge_amount" class="list-item-nominal-price" />
              </div>
              <div v-if="Number(order.tax_amount) > 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $store.state.selected_outlet.tax_name ? $store.state.selected_outlet.tax_name : $t('v2.tax') }}
                </div>
                <v-spacer />
                <div v-mask-money-only="order.tax_amount" class="list-item-nominal-price" />
              </div>
              <div v-if="Number(order.rounded_amount) > 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.rounding') }}
                </div>
                <v-spacer />
                <div v-mask-money-only="order.rounded_amount" class="list-item-nominal-price" />
              </div>
              <div v-else-if="Number(order.rounded_amount) < 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.rounding') }}
                </div>
                <v-spacer />
                <div v-mask-money-only="order.rounded_amount" class="list-item-nominal-price ol-accent" />
              </div>
            </div>
            <div class="line-dot my-4" />
            <div class="total-price">
              <div class="total-price-title">
                {{ $t('v2.total') }}
              </div>
              <v-spacer />
              <div v-mask-money="order.total_amount" class="total-nominal-price" />
            </div>
            <div v-if="order.payment_mode_id === 10" class="total-price pt-6">
              <div class="total-price-title">
                {{ $t('v2.payment_method') }}
              </div>
              <v-spacer />
              <div class="total-nominal-price">
                {{ $t('v2.pay_at_the_cashier') }}
              </div>
            </div>
            <div v-else-if="!$isEmpty(order.payment_log) && order.payment_log.payment_source === 'VIRTUAL-ACCOUNT'" class="total-price pt-6">
              <div class="total-price-title">
                {{ $t('v2.payment_method') }}
              </div>
              <v-spacer />
              <div class="total-nominal-price">
                BANK {{ order.payment_log.va_bank_code }}
              </div>
            </div>
            <div v-else-if="!$isEmpty(order.payment_log)" class="total-price pt-6">
              <div class="total-price-title">
                {{ $t('v2.payment_method') }}
              </div>
              <v-spacer />
              <div class="total-nominal-price">
                {{ order.payment_log.payment_type }}
              </div>
            </div>
            <div v-else class="total-price pt-6">
              <div class="total-price-title">
                {{ $t('v2.payment_method') }}
              </div>
              <v-spacer />
              <div class="total-nominal-price">
                {{ order.payment_mode_name }}
              </div>
            </div>
            <template v-if="!$isEmpty(order.points) && order.points.earned_points > 0">
              <div class="line-dot my-6" />
              <div class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.point_earned') }}
                </div>
                <v-spacer />
                <div class="list-item-nominal-price ol-accent">
                  +{{ Number(order.points.earned_points) }} pts
                </div>
              </div>
            </template>
          </div>
          <div class="mt-4">
            <template v-for="(item, idx) in order.items">
              <div v-if="item.note === 'REDEEMED'" :key="idx" class="mb-2">
                <div class="flex-image pa-4 bg-accent-soft br-8">
                  <div class="mr-2">
                    <img src="@/assets/images/v2/img/icon_point.png" alt="Voucher" class="image-22">
                  </div>
                  <div class="flex-image-content">
                    <div class="flex-image-content-text font-14 font-weight-600 ol-black two-line">
                      {{ Number(item.qty) }}x {{ item.item_name }} {{ item.item_variant_name ? '(' + item.item_variant_name + ')' : '' }}
                    </div>
                    <div class="flex-image-content-text font-12 font-weight-400 ol-grey-content">
                      {{ $t('v2.from_point_exchange') }}
                    </div>
                  </div>
                  <div class="font-12 font-weight-400 ol-black ml-2">
                    {{ !$isEmpty(order.points) && order.points.redeemed_amount && Number(order.points.redeemed_amount) ? '-' + Number(order.points.redeemed_points) + ' pts' : '' }}
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="mt-10">
            <v-btn v-if="order.status_inquiry === 5" outlined block color="olbrand" height="40" class="br-5 font-weight-700 text-none ol-elevation-1 mb-2 letter-spacing-normal" @click="openSplitBill()">
              {{ $t('v2.split_bill') }}
            </v-btn>
            <v-btn block color="primary" height="40" class="br-5 ol-red font-weight-700 text-none white--text ol-elevation-1 letter-spacing-normal" @click="reOrder()">
              {{ $t('v2.reorder') }}
            </v-btn>
          </div>
          <v-bottom-sheet v-model="dialog_split_bill" persistent content-class="sheet-full">
            <v-sheet style="height: 100%" class="br-0">
              <div class="sheet-app-bar">
                <div class="sheet-app-bar-content">
                  <v-container class="px-0">
                    <v-row>
                      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
                        <div class="flex-image">
                          <div class="flex-image-avatar mr-2">
                            <v-btn icon width="40" height="40" @click="closeSplitBill()">
                              <v-icon>
                                mdi-arrow-left
                              </v-icon>
                            </v-btn>
                          </div>
                          <div class="flex-image-content">
                            <div class="flex-image-content-text font-20 font-weight-bold">
                              {{ $t('v2.split_bill') }}
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
              </div>
              <v-container class="pt-0">
                <v-row>
                  <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
                    <template v-if="split_bill.step === 'form'">
                      <div v-if="split_bill.people.length > 0" class="mb-4">
                        <div class="font-12 font-weight-600 mb-2 ol-grey-content">
                          {{ $t('v2.people_added') }} ({{ split_bill.people.length }})
                        </div>
                        <div v-for="person in split_bill.people" :key="person.id" class="d-flex align-center mb-2">
                          <div class="font-14 font-weight-600">
                            {{ person.name }}
                          </div>
                          <div class="font-12 ol-grey-content ml-2">
                            {{ person.item_idx.length }} item
                          </div>
                          <v-spacer />
                          <v-btn icon small @click="removePersonSplitBill(person.id)">
                            <v-icon size="18">
                              mdi-close
                            </v-icon>
                          </v-btn>
                        </div>
                        <div class="div-line my-3" />
                      </div>

                      <label class="font-12">{{ $t('v2.person_name') }}</label>
                      <v-text-field v-model="split_bill.current_name" outlined dense hide-details :placeholder="$t('v2.person_name_placeholder')" class="inputv2-space mb-4" />

                      <label class="font-12">{{ $t('v2.select_menu_for', { name: split_bill.current_name || '...' }) }}</label>
                      <div v-for="(item, idx) in splitBillItems" :key="idx" class="d-flex align-center py-2">
                        <v-checkbox v-model="split_bill.current_item_idx" :value="idx" hide-details class="mt-0 pt-0" />
                        <div class="ml-2">
                          <div class="font-14 font-weight-600">
                            {{ item.qty }}x {{ item.item_name }} {{ item.item_variant_name ? '(' + item.item_variant_name + ')' : '' }}
                          </div>
                          <div class="font-12 ol-grey-content">
                            <span v-mask-money="item.amount" />
                          </div>
                        </div>
                      </div>

                      <v-btn outlined color="olbrand" block height="40" class="text-none br-5 font-weight-700 letter-spacing-normal mt-4" :disabled="!split_bill.current_name || split_bill.current_item_idx.length === 0" @click="addPersonSplitBill()">
                        {{ $t('v2.add_another_person') }}
                      </v-btn>
                      <v-btn color="primary" block height="40" class="text-none white--text br-5 font-weight-700 ol-elevation-1 letter-spacing-normal mt-2" :disabled="split_bill.people.length === 0 && (!split_bill.current_name || split_bill.current_item_idx.length === 0)" @click="showSplitBillResult()">
                        {{ $t('v2.view_result') }}
                      </v-btn>
                    </template>
                    <template v-else>
                      <div v-for="result in splitBillResult" :key="result.id" class="mb-4 pa-3 ol-elevation-2 br-8">
                        <div class="d-flex align-center mb-2">
                          <div class="font-16 font-weight-700">
                            {{ result.name }}
                          </div>
                          <v-spacer />
                          <div class="font-16 font-weight-700">
                            <span v-mask-money="result.total" />
                          </div>
                        </div>
                        <div v-for="line in result.lines" :key="line.idx" class="d-flex font-12 ol-grey-content">
                          <div>
                            {{ line.qty }}x {{ line.name }}<span v-if="line.shared_count > 1"> ({{ $t('v2.shared_with', { count: line.shared_count }) }})</span>
                          </div>
                          <v-spacer />
                          <span v-mask-money="line.share_amount" />
                        </div>
                        <template v-if="result.fees.length > 0">
                          <div class="div-line my-2" />
                          <div v-for="fee in result.fees" :key="fee.key" class="d-flex font-12 ol-grey-content">
                            <div>
                              {{ fee.label }}
                            </div>
                            <v-spacer />
                            <span v-mask-money="fee.amount" />
                          </div>
                        </template>
                      </div>

                      <div v-if="splitBillUnassignedItems.length > 0" class="mb-4 pa-3 bg-grey br-8">
                        <div class="font-12 font-weight-600 mb-2">
                          {{ $t('v2.unassigned_items') }}
                        </div>
                        <div v-for="(item, idx) in splitBillUnassignedItems" :key="idx" class="font-12 ol-grey-content">
                          {{ item.qty }}x {{ item.item_name }}
                        </div>
                      </div>

                      <div class="font-12 ol-grey-content mb-4">
                        {{ $t('v2.split_bill_estimation_note') }}
                      </div>

                      <v-btn color="primary" block height="40" class="text-none white--text br-5 font-weight-700 ol-elevation-1 letter-spacing-normal mb-2" @click="shareSplitBillResult()">
                        {{ $t('v2.share_result') }}
                      </v-btn>
                      <v-btn outlined color="olbrand" block height="40" class="text-none br-5 font-weight-700 letter-spacing-normal" @click="split_bill.step = 'form'">
                        {{ $t('v2.back_to_edit') }}
                      </v-btn>
                    </template>
                  </v-col>
                </v-row>
              </v-container>
            </v-sheet>
          </v-bottom-sheet>
          <alert v-model="dialog_alert.show" :message="dialog_alert.message" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {
  checkMaterial as checkStockMaterial
} from '@/api/product'
import {
  getDataDetail as getDataDetailOrder
} from '@/api/order'
import { checkInventory, prepareCartItem, validateStockMaterial } from '@/utils/order'
import Alert from '@/components/v2/Alert'
export default {
  components: {
    Alert
  },
  data() {
    return {
      dialog_alert: {
        show: false,
        message: ''
      },
      icon_table: require('@/assets/images/v2/img/icon_table.png'),
      icon_side_reservation: require('@/assets/images/v2/img/icon-side-reservation.png'),
      order: {},
      expired_time: 0,
      timerOrderInterval: null,
      cart: {},
      temp_cart: {},
      materials: [],
      dialog_split_bill: false,
      split_bill: {
        step: 'form',
        people: [],
        current_name: '',
        current_item_idx: []
      }
    }
  },
  computed: {
    splitBillItems() {
      if (!this.order || !this.order.items) return []
      return this.order.items.filter((item) => item.note !== 'REDEEMED')
    },
    splitBillAssigneeCount() {
      const count = {}
      this.split_bill.people.forEach((person) => {
        person.item_idx.forEach((idx) => {
          count[idx] = (count[idx] || 0) + 1
        })
      })
      return count
    },
    splitBillUnassignedItems() {
      const count = this.splitBillAssigneeCount
      return this.splitBillItems.filter((item, idx) => !count[idx])
    },
    splitBillFeeFields() {
      const order = this.order
      const isPointDiscount = !this.$isEmpty(order.points) && order.points.type === 'D'
      return [
        { key: 'discount', label: this.$t('v2.discount'), amount: Number(order.discount_amount) || 0, sign: -1 },
        { key: 'points', label: this.$t('v2.voucher_point'), amount: isPointDiscount ? Number(order.points.redeemed_amount) || 0 : 0, sign: -1 },
        { key: 'service_charge', label: this.$t('v2.service_charge'), amount: Number(order.service_charge_amount) || 0, sign: 1 },
        { key: 'shipping', label: this.$t('v2.delivery_fee'), amount: Number(order.shipping_cost) || 0, sign: 1 },
        { key: 'trans_fee', label: this.$t('v2.convenience_fee'), amount: Number(order.trans_fee_amount) || 0, sign: 1 },
        { key: 'tax', label: this.$store.state.selected_outlet.tax_name ? this.$store.state.selected_outlet.tax_name : this.$t('v2.tax'), amount: Number(order.tax_amount) || 0, sign: 1 },
        { key: 'rounding', label: this.$t('v2.rounding'), amount: Number(order.rounded_amount) || 0, sign: 1 }
      ]
    },
    splitBillResult() {
      const assigneeCount = this.splitBillAssigneeCount
      const items = this.splitBillItems
      const subtotal = Number(this.order.order_amount) || 0
      const feeFields = this.splitBillFeeFields.filter((fee) => fee.amount > 0)
      return this.split_bill.people.map((person) => {
        let personSubtotal = 0
        const lines = person.item_idx.map((idx) => {
          const item = items[idx]
          const sharedCount = assigneeCount[idx] || 1
          const shareAmount = Number(item.amount) / sharedCount
          personSubtotal += shareAmount
          return {
            idx,
            name: item.item_name + (item.item_variant_name ? ' (' + item.item_variant_name + ')' : ''),
            qty: item.qty,
            shared_count: sharedCount,
            share_amount: shareAmount
          }
        })
        const ratio = subtotal > 0 ? personSubtotal / subtotal : 0
        const fees = feeFields.map((fee) => ({
          key: fee.key,
          label: fee.label,
          amount: fee.sign * (ratio * fee.amount)
        }))
        const feesTotal = fees.reduce((sum, fee) => sum + fee.amount, 0)
        return {
          id: person.id,
          name: person.name,
          lines,
          fees,
          total: Math.round(personSubtotal + feesTotal)
        }
      })
    },
    formattedTimeLeft() {
      let days = Math.floor(this.expired_time / (1000 * 60 * 60 * 24))
      let hours = Math.floor((this.expired_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((this.expired_time % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((this.expired_time % (1000 * 60)) / 1000)
      let result
      if (this.expired_time < 0) {
        result = 'EXPIRED'
      } else {
        days = days === 0 ? '' : days + ' : '
        hours = hours < 10 ? hours === 0 ? '' : '0' + hours + ' : ' : hours + ' : '
        minutes = minutes < 10 ? '0' + minutes + ':' : minutes + ':'
        seconds = seconds < 10 ? '0' + seconds : seconds
        result = days + hours + minutes + seconds
      }
      return result
    }
  },
  beforeDestroy() {
    clearInterval(this.timerOrderInterval)
  },
  mounted() {
    this.getOrder()
    const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
    if (LOCAL_DATA_CART) {
      this.cart = JSON.parse(LOCAL_DATA_CART)
    }
  },
  methods: {
    notTakeaway(note) {
      const arrNote = note.split(',')
      if (arrNote[0] === 'TAKE AWAY') {
        arrNote.splice(0, 1)
      }
      return arrNote.toString()
    },
    isTakeaway(note) {
      const arrNote = note.split(',')
      if (arrNote[0] === 'TAKE AWAY') {
        return true
      }
      return false
    },
    refreshPage() {
      location.reload()
    },
    goBack() {
      this.$router.push({ name: '_transactions' }).catch(() => {})
    },
    backToMenu() {
      this.$router.push({ name: '_menu' }).catch(() => {})
    },
    splitBillStorageKeyPrefix() {
      return process.env.VUE_APP_COOKIE_KEY + '_split_bill_'
    },
    splitBillStorageKey() {
      return this.splitBillStorageKeyPrefix() + this.order.id
    },
    cleanupSplitBillDrafts() {
      const prefix = this.splitBillStorageKeyPrefix()
      const maxAgeMs = 7 * 24 * 60 * 60 * 1000
      const now = Date.now()
      Object.keys(localStorage)
        .filter((key) => key.indexOf(prefix) === 0)
        .forEach((key) => {
          try {
            const draft = JSON.parse(localStorage.getItem(key))
            if (!draft || !draft.updated_at || (now - draft.updated_at) > maxAgeMs) {
              localStorage.removeItem(key)
            }
          } catch (e) {
            localStorage.removeItem(key)
          }
        })
    },
    loadSplitBillDraft() {
      try {
        const raw = localStorage.getItem(this.splitBillStorageKey())
        const draft = raw ? JSON.parse(raw) : null
        return draft && draft.people ? draft.people : []
      } catch (e) {
        return []
      }
    },
    saveSplitBillDraft() {
      localStorage.setItem(this.splitBillStorageKey(), JSON.stringify({
        people: this.split_bill.people,
        updated_at: Date.now()
      }))
    },
    openSplitBill() {
      this.cleanupSplitBillDrafts()
      this.split_bill = {
        step: 'form',
        people: this.loadSplitBillDraft(),
        current_name: '',
        current_item_idx: []
      }
      this.dialog_split_bill = true
    },
    closeSplitBill() {
      this.dialog_split_bill = false
    },
    addPersonSplitBill() {
      if (!this.split_bill.current_name || this.split_bill.current_item_idx.length === 0) return
      this.split_bill.people.push({
        id: this.split_bill.people.length + 1,
        name: this.split_bill.current_name.trim(),
        item_idx: [...this.split_bill.current_item_idx]
      })
      this.split_bill.current_name = ''
      this.split_bill.current_item_idx = []
      this.saveSplitBillDraft()
    },
    removePersonSplitBill(id) {
      this.split_bill.people = this.split_bill.people.filter((person) => person.id !== id)
      this.saveSplitBillDraft()
    },
    showSplitBillResult() {
      if (this.split_bill.current_name && this.split_bill.current_item_idx.length > 0) {
        this.addPersonSplitBill()
      }
      this.split_bill.step = 'result'
    },
    async shareSplitBillResult() {
      const lines = [this.$t('v2.split_bill') + ' - ' + this.order.store_name]
      this.splitBillResult.forEach((result) => {
        lines.push('')
        lines.push(result.name + ': ' + this.$maskMoney(result.total))
        result.lines.forEach((line) => {
          lines.push('- ' + line.qty + 'x ' + line.name + ': ' + this.$maskMoney(line.share_amount))
        })
        result.fees.forEach((fee) => {
          lines.push('- ' + fee.label + ': ' + this.$maskMoney(fee.amount))
        })
      })
      const text = lines.join('\n')
      if (navigator.share) {
        try {
          await navigator.share({ title: this.$t('v2.split_bill'), text })
        } catch (e) {
          // user membatalkan share sheet
        }
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text)
        this.$store.state.show_error = true
        this.$store.state.error_message = this.$t('v2.split_bill_copied')
        this.$store.state.error_type = 200
      }
    },
    async getOrder() {
      try {
        let params = {}
        if (this.$store.state.selected_store.setting.no_auth_dinein) {
          params = {
            remark: 'OL-DINE-IN'
          }
        }
        const { data } = await getDataDetailOrder(this.$route.params.id, params)
        this.order = data.data
        if (!this.$isEmpty(this.order.payment_log) && this.order.payment_log.expired_at) {
          this.getExpiryTime(this.order.payment_log.expired_at)
        }
        if (this.order.is_paid) {
          clearInterval(this.timerOrderInterval)
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    textAddons(item) {
      if (item.product_combo_id) {
        const arr = []
        for (let i = 0; i < item.item_product_combo.length; i++) {
          arr.push(item.item_product_combo[i].item_name)
        }
        return arr.join(', ')
      } else {
        if (typeof item.addon !== 'undefined' && item.addon.length !== 0) {
          const names = item.addon.map(function(item) {
            return item['name']
          })
          return names.join(', ')
        } else {
          return ''
        }
      }
    },
    getExpiryTime(time) {
      var countDownDate = new Date(time).getTime()
      const _this = this
      this.timerOrderInterval = setInterval(function() {
        var now = new Date().getTime()
        _this.expired_time = countDownDate - now
        if (_this.expired_time < 0) {
          clearInterval(_this.timerOrderInterval)
        }
      }, 1000)
    },
    async reOrder() {
      const cart = []
      let reorder = true
      for (const item of this.order.items) {
        if (item.product_has_material && !item.track_inventory) {
          await this.checkStockMaterialObj({
            product_id: item.product_id || undefined,
            product_variant_id: item.product_variant_id || undefined
          })
        }
        if (await checkInventory(item, this.materials)) {
          reorder = false
          break
        }
        if (item.note !== 'REDEEMED') {
          cart.push(prepareCartItem(item, this.materials))
        }
      }

      reorder = reorder && await validateStockMaterial(cart)

      if (reorder) {
        this.cart.item = cart
        await this.$store.dispatch('saveCartV2', this.cart)
        this.$router.push({ name: '_checkout' }).catch(() => {})
      }
    },
    async checkStockMaterialObj(objId) {
      try {
        const { data } = await checkStockMaterial(objId)
        this.materials = data.data.materials
      } catch (e) {
        this.materials = []
        Object.assign(this.$store.state, {
          show_error: true,
          error_message: e.string,
          error_type: e.statusCode
        })
      }
    }
  }
}
</script>
